import React, { Component } from 'react';
import { _imageSave } from './actions';
import {toastr} from 'react-redux-toastr'
import PropTypes from 'prop-types'

class AddImage extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  onChange = (e) => {
    e.preventDefault();
    const {formatMessage} = this.context
    let reader = new FileReader();
    let file = e.target.files[0];


    if(file.size == 0){
      // error
      toastr.error(formatMessage('titleImgSiteError'), formatMessage('msgImgSiteError'));
      e.target.value = null;
      return false;
    }
    
    

    if(file.size/1024 >= 5 * 1024){
      // error
      toastr.error(formatMessage('titleImgSiteError'), formatMessage('msgImgSiteError'));
      e.target.value = null;
      return false;
    }

    var allowedExtensions = /(\.|\.jpeg|\.png|\.jpg)$/i;
    if(!allowedExtensions.exec(file.name)){
        // error
        toastr.error(formatMessage('titleImgExtensionError'), formatMessage('msgImgExtensionError'))
        return false;
    }
    

    reader.onloadend = () => {
      this.props.setSpiner(true)
      _imageSave({
        file,
        questionId: 'questions_imgs',
      }).then(result => {
        this.props.setSpiner(false)
        if(this.props.insertImage){
          this.props.insertImage(result.uploadedImg)
        }
      }).catch(err => {
        this.props.setSpiner(false)
      })
    }
    reader.readAsDataURL(file)
  }


  render() {
    return (
      <label>
        <i className="far fa-image"></i>
        <input type="file" style={{display: 'none'}} accept=".png, .jpg, .jpeg" onChange={this.onChange} />
      </label>
      
    );
  }
}

export default AddImage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/AddImage.jsx